export default {
  methods: {
    mixin_ShowInfoMsg(msg) {
      let alert = [true, "infoColor", msg, "mdi-alert-circle"];
      this.$store.dispatch("SetAlert", alert);
    },
    mixin_ShowSuccessMsg(msg) {
      let alert = [true, "successColor", msg, "mdi-check-circle"];
      this.$store.dispatch("SetAlert", alert);
    },
    mixin_ShowErrorMsg(msg) {
      let alert = [true, "errorColor", msg, "mdi-alert-circle"];
      this.$store.dispatch("SetAlert", alert);
    },
  },
};
